import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { base_url } from "./AgentWhitelist";

const CasinoReport = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [casino, setCasino] = useState([]);
  const [fullCasino, setFullCasino] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [bets, setBets] = useState(0);
  const [wins, setWins] = useState(0);
  const [ggr, setGgr] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 50;
// Pagination Logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = casino.slice(indexOfFirstItem, indexOfLastItem);

const totalPages = Math.ceil(casino.length / itemsPerPage);

// Reset to page 1 when filtered
useEffect(() => {
  setCurrentPage(1);
}, [search, startDate, endDate]);


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const casinoData = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.get(base_url + "/api/webapi/casinoData", {
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      });

      if (response?.data?.success) {
        const data = response?.data?.result;
        
       const totals = data.reduce(
  (acc, bet) => {
    acc.amount += Number(bet.amount) || 0;
    acc.ggr += Number(bet.ggr) || 0;
    acc.wins += Number(bet.profit) || 0;
    return acc;
  },
  { amount: 0, ggr: 0, wins: 0 }
);

setCasino(data);
setFullCasino(data);

setBets(totals.amount.toFixed(2));
setWins(totals.wins.toFixed(2));
setGgr(totals.ggr.toFixed(2));

        
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleFilter = () => {
    let filteredData = [...fullCasino];

    // ✅ filter by playerId
    if (search !== "") {
      filteredData = filteredData.filter((row) =>
        row.playerId.toLowerCase().includes(search.toLowerCase()) || row.customerId.toLowerCase().includes(search.toLowerCase()) || row.agentId.toLowerCase().includes(search.toLowerCase())
      );
    }

    // ✅ filter by date range
    if (startDate && endDate) {
      const start = new Date(startDate + "T00:00:00");
      const end = new Date(endDate + "T23:59:59");

      filteredData = filteredData.filter((row) => {
        // row.time is like "2025/08/26 05:06:40 PM"
        const [datePart, timePart, ampm] = row.time.split(" ");
        const [yyyy, mm, dd] = datePart.split("/").map(Number);
        let [hh, min, ss] = timePart.split(":").map(Number);

        if (ampm === "PM" && hh !== 12) hh += 12;
        if (ampm === "AM" && hh === 12) hh = 0;

        const rowDate = new Date(yyyy, mm - 1, dd, hh, min, ss);

        return rowDate >= start && rowDate <= end;
      });
    }

    setCasino(filteredData);
  };


  useEffect(() => {
    casinoData();
  }, []);

  useEffect(() => {
    handleFilter();
  }, [search, startDate, endDate]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="wrapper bg-light">
      <AdminSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} isMobile={isMobile} />
      <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} isMobile={isMobile} />

      <div
        className={`content-wrapper p-1 ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"}`}
        style={{ marginLeft: !isMobile && isSidebarOpen ? "" : "0" }}
      >
        <div className={`main-content ${isSidebarOpen ? "with-sidebar" : ""}`}>
          <div className="container-fluid py-4">
            <h3 className="text-dark mb-4">🎰 Casino Bets Report</h3>

            {/* 🔍 Search & Filter Section */}
            <div className="row g-3 mb-3">
              <div className="col-md-4">
                <input
                  type="text"
                  placeholder="Enter Player ID"
                  className="form-control"
                  value={search}
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-outline-secondary w-100"
                  onClick={() => {
                    setCasino(fullCasino);
                    setSearch("");
                    setStartDate("");
                    setEndDate("");
                  }}
                >
                  Reset
                </button>
              </div>
            </div>

            <div className="d-flex justify-content-between flex-wrap w-100">
              <div className="card d-flex flex-row gap-2 rounded p-3">
                Total Bets:<span className="text-primary">{bets || 0}</span>
              </div>

              <div className="card d-flex flex-row gap-2 rounded p-3">
                Total Wins:<span className="text-success">{wins || 0}</span>
              </div>

              <div className="card d-flex flex-row gap-2 rounded p-3">
                Total GGR:<span className="text-danger">{ggr || 0}</span>
              </div>
            </div>

            {/* 📊 Table */}
            {casino.length === 0 ? (
              <div className="text-center py-5 text-muted">No Casino Bets Found</div>
            ) : (
              <div className="table-responsive shadow-sm rounded bg-white p-3 w-100">
                <table className="table-hover align-middle mb-0 w-100 overflow-auto">
                  <thead style={{ backgroundColor: "#182848", color: "white" }}>
                    <tr className="text-center text-nowrap border border-black">
                      <th className="px-3 text-nowrap">Player ID</th>
                      <th className="px-3 text-nowrap">Game</th>
                      <th className="px-3 text-nowrap">Game Round</th>
                      <th className="px-3 text-nowrap">Bet Amount</th>
                      <th className="px-3 text-nowrap">GGR</th>                      
                      <th className="px-3 text-nowrap">Win Amount</th>
                      <th className="px-3 text-nowrap">Before Balance</th>
                      <th className="px-3 text-nowrap">After Balance</th>
                      <th className="px-3 text-nowrap">Status</th>
                      <th className="px-3 text-nowrap">Time</th>
                      <th className="px-3 text-nowrap">Result Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((row) => (
                      <tr key={row.id} className={`text-center text-nowrap border border-dark`}>
                        <td className="px-3 py-2">{row.playerId}</td>
                        <td className="px-3">{row.gameId}</td>
                        <td className="px-3">{row.roundId}</td>
                        <td className="px-3">{parseFloat(row.amount).toFixed(2)}</td>
                        <td className="px-3 text-danger">{parseFloat(row.ggr).toFixed(2)}</td>                        
                        <td className="px-3 text-success">
                          
                          {row.profit > 0
                            ? (row.profit - row.amount).toFixed(2)
                            : row.profit}
                        </td>
                        <td className="px-3">{parseFloat(row.old_balance).toFixed(2)}</td>
                        <td className="px-3">{parseFloat(row.balance).toFixed(2)}</td>
                        <td className="px-3">
                          {row.status === 1 ? (
                            <span className="badge bg-success">Win</span>
                          ) : row.status === 2 ? (
                            <span className="badge bg-danger">Loss</span>
                          ) : (
                            <span className="badge bg-warning">Pending</span>
                          )}
                        </td>
                        <td className="px-3">
                          {row.time}

                        </td>
                        <td className="px-3">
                          {row.result_time}

                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="d-flex justify-content-center mt-3 gap-2">

  <button
    className="btn btn-sm btn-dark"
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(currentPage - 1)}
  >
    Prev
  </button>

  {/* {[...Array(totalPages)].map((_, i) => (
    <button
      key={i}
      className={`btn btn-sm ${currentPage === i + 1 ? "btn-primary" : "btn-outline-primary"}`}
      onClick={() => setCurrentPage(i + 1)}
    >
      {i + 1}
    </button>
  ))} */}

  <button
    className="btn btn-sm btn-dark"
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage(currentPage + 1)}
  >
    Next
  </button>

</div>

              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CasinoReport;
